var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',[_c('v-tab',{attrs:{"to":"/kpi"}},[_vm._v(_vm._s(_vm.$t('kpi.index.text.daily')))]),_c('v-tab',{attrs:{"to":"/kpi/monthly"}},[_vm._v(_vm._s(_vm.$t('kpi.index.text.monthly')))])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }